<style lang="scss" scoped>
.star {
  display: flex;
  flex-wrap: wrap;
  // align-items: stretch;
  padding-bottom: 0;
  padding-right: 0;
}
.star-card {
  box-sizing: border-box;
  width: 25%;
  flex: none;
  padding-right: 15px;
  padding-bottom: 15px;
}
.star-card-content {
  position: relative;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #eee;
  background-color: #fafafa;
}
.star-line {
  display: flex;
}
.star-line + .star-line {
  margin-top: 10px;
}
.star-line-left {
  flex: none;
  width: 60px;
  text-align: right;
  line-height: 20px;
  font-size: 14px;
  color: #909399;
  margin: 0;
  margin-right: 10px;
}
.star-line-right {
  flex: auto;
  line-height: 20px;
  font-size: 14px;
  margin: 0;
  color: #606266;
}
.star-avatar {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 64px;
  height: 64px;
  font-size: 30px;
  line-height: 62px;
  text-align: center;
  border: 1px solid #eee;
  background-size: cover;
  background-repeat: none;
  background-position: center;
  color: #606266;
}
.star-operation {
  text-align: right;
  margin: 0;
  margin-top: 10px;
  button {
    padding: 2px 0;
  }
}
.introduction {
  height: 64px;
  overflow: scroll;
}
.no-wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<template>
  <div>
    <div class="container">
      <el-button type="primary" @click="() => startAdd()">添加明星教师</el-button>
    </div>

    <div class="container star">
      <div class="star-card" v-for="item of list" :key="item.id">
        <div class="star-card-content">
          <div class="star-line">
            <p class="star-line-left">姓名</p>
            <p class="star-line-right no-wrap" style="padding-right: 60px;">{{ item.name }}</p>
          </div>
          <div class="star-line">
            <p class="star-line-left">职称</p>
            <p class="star-line-right no-wrap" style="padding-right: 60px;">{{ item.title }}</p>
          </div>
          <div class="star-line">
            <p class="star-line-left">教育背景</p>
            <p class="star-line-right no-wrap">{{ item.background }}</p>
          </div>
          <div class="star-line">
            <p class="star-line-left">简介</p>
            <p class="star-line-right introduction">{{ item.introduction }}</p>
          </div>
          <p class="star-operation">
            <el-button type="text" @click="() => startDelete(item)">删除</el-button>
            <el-button type="text" @click="() => startEdit(item)">编辑</el-button>
          </p>
          <div
            class="star-avatar"
            :style="{
              backgroundImage: `url(${item.avatar})`
            }"
          >
            {{ item.avatar ? '' : item.name ? item.name[0] : '' }}
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="current.id ? '修改明星教师信息' : '添加明星教师'" :visible.sync="editDialogVisible" width="60%">
      <el-form :model="current" :rules="rules" label-width="80px" label-position="right" ref="editForm">
        <el-form-item label="头像">
          <upload-file :limit="1" accept="image/*" v-model="current.avatar"></upload-file>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="current.name"></el-input>
        </el-form-item>
        <el-form-item label="职称" prop="title">
          <el-input v-model="current.title"></el-input>
        </el-form-item>
        <el-form-item label="教育背景">
          <el-input v-model="current.background"></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <el-input type="textarea" v-model="current.introduction"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';
import UploadFile from '../../components/uploadFile/index.vue';

export default {
  components: { UploadFile },
  data() {
    return {
      token: getToken(),
      list: [],
      current: {
        name: '',
        title: '',
        background: '',
        introduction: '',
        avatar: ''
      },
      rules: {
        name: [{ required: true, message: '请填写教师姓名' }],
        title: [{ required: true, message: '请填写教师职称' }]
      },
      editDialogVisible: false
    };
  },
  created() {
    rpc(
      'StoreTeacherService.GetTeacherList',
      M('TeacherListQueryRequest', {
        token: M('Token', { token: this.token }),
        count: 100
      })
    ).then(res => {
      this.list = res.teacherlistList;
    });
  },
  methods: {
    startAdd() {
      this.current = {
        name: '',
        title: '',
        background: '',
        introduction: '',
        avatar: ''
      };
      this.editDialogVisible = true;
    },
    startEdit(row) {
      this.current = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
    },
    startDelete(row) {
      this.$confirm(`确认要删除“${row.name}”吗？`, '删除明星教师', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.remove(row);
        })
        .catch(e => {});
    },
    remove(row) {
      rpc(
        'StoreTeacherService.DeleteTeacher',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: row.id
        })
      ).then(() => {
        this.list.splice(this.list.findIndex(v => v.id == row.id), 1);
        this.$message({
          message: '删除成功！',
          type: 'success'
        });
      });
    },
    confirmEdit() {
      this.$refs.editForm.validate(res => {
        if (res) {
          if (this.current.id) {
            rpc(
              'StoreTeacherService.UpdateTeacher',
              M('TeacherWithTokenRequest', {
                token: M('Token', { token: this.token }),
                teacher: M('Teacher', this.current)
              })
            ).then(res => {
              this.list.splice(this.list.findIndex(v => v.id == res.id), 1, res);
              this.editDialogVisible = false;
              this.$message({
                message: '修改成功！',
                type: 'success'
              });
            });
            return;
          }
          rpc(
            'StoreTeacherService.CreateTeacher',
            M('TeacherWithTokenRequest', {
              token: M('Token', { token: getToken() }),
              teacher: M('Teacher', this.current)
            })
          ).then(res => {
            this.list.splice(0, 0, res);
            this.editDialogVisible = false;
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
          });
        }
      });
    }
  }
};
</script>
